export class SelectBox {

	constructor($el) {
		// $el is the blk node return by the loadSelectBox function
		this.$el = $el;
		this._onChange = () => {};
	}

	init() {
		this.initSelectbox(this.$el);
		return this;
	}

	initSelectbox($el) {
		const This = this;
		$($el).find('.dropdown-item:not(.disabled)').click(function() {
			const $parent = $(this).closest('.selectbox');
			const $title = $parent.find('.selectbox-title');

			$title.text(this.dataset.name || '');

			$parent.attr('data-name', this.dataset.name || '');
			$parent.attr('data-value', this.dataset.value || '');
			$parent.trigger('change', [this.dataset, this]);
			This._onChange(this.dataset, this);
		});
	}

	onChange(callBack) {
		this._onChange = callBack;
		return this;
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/blocks/selectbox/js/selectbox.js